import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Benefits from './components/Benefits';
import SocialProof from './components/SocialProof';
import Process from './components/Process';
import DemoVideos from './components/DemoVideos';
import Industries from './components/Industries';
import Pricing from './components/Pricing';
import CTA from './components/CTA';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';
import QuickbotDemo from './components/QuickbotDemo';
import SupportDemo from './components/SupportDemo';

function LandingPage() {
  return (
    <div>
      <Hero />
      <Benefits />
      <SocialProof />
      <Process />
      <DemoVideos />
      <Industries />
      <Pricing />
      <CTA />
      <Footer />
      <StickyCTA />
    </div>
  );
}

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/quickbot-demo" element={<QuickbotDemo />} />
        <Route path="/support-demo" element={<SupportDemo />} />
      </Routes>
    </div>
  );
}

export default App;